/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PlatformAdminUIState, PlatformAdminUIThunkType } from '../../store/store';
import { getAppConfigs } from './store/AppConfig.actions';
import AppConfigListView from './AppConfigList.view';
import { RouteComponentProps } from 'react-router-dom';
import { AppConfigActionTypes } from './store/AppConfigActionTypes';
import { ClientTenantAndAppVariantEntry } from '@DigitaleDoerfer/digitale-doerfer-api';

interface Props extends RouteComponentProps {
	appConfigs: ClientTenantAndAppVariantEntry[];
	loading: boolean;
	getAppConfigs: () => void;
}

class AppConfigListContainer extends Component<Props> {
	componentDidMount(): void {
		this.props.getAppConfigs();
	}

	render(): JSX.Element {
		const { appConfigs, loading } = this.props;
		return <AppConfigListView appConfigs={appConfigs} loading={loading} />;
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		appConfigs: state.appConfig.list.appConfigs,
		loading: state.appConfig.list.loading
	};
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: PlatformAdminUIThunkType<AppConfigActionTypes>) => {
	return {
		getAppConfigs: (): Promise<void> => dispatch(getAppConfigs())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppConfigListContainer);
